import React from "react";
import { useAuthorization } from "@common/providers";
import ScopeStackSpinner from "@components/ScopeStackSpinner/ScopeStackSpinner";
import { Route, Routes } from "react-router";
import Show from "./Show";

const TravelAndExpenseV2Mspa = ({ project_id }): JSX.Element => {
  const authorized = useAuthorization();
  if (!authorized) {
    return <ScopeStackSpinner />;
  }

  return (
    <div className="tab-content">
      <div className="tab-pane active">
        <Routes>
          <Route path="/" element={<Show project_id={project_id} />} />
        </Routes>
      </div>
    </div>
  );
};

export default TravelAndExpenseV2Mspa;
